// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"z5-z","dimensionLabel":"A5-z","styleChooserControlWrapper":"B5-z","styleChooserControl":"C5-z","disabled":"D5-z","giftCard":"E5-z","styleChooserText":"F5-z"};